<style>
#servitudeSymbologyModal .v--modal-box.v--modal {
  min-height: 270px !important;
  min-width: 400px !important;
}
#servitudeSymbologyModal .modal__content {
  margin-top: -60px;
}
#servitudeSymbologyModal .modal__footer {
  display: none;
}
.select__wrapper {
  width: 100%;
}
#servitudeSymbologyModal .v-text-field__slot input,
#servitudeSymbologyModal .v-select__selections {
  font-size: 12px;
}
#servitudeSymbologyModal .color__box {
  height: 20px;
  width: 20px;
  border: solid 2px rgba(122, 122, 122, 0.8);
  border-radius: 4px;
  box-sizing: border-box;
  background-color: aqua;
}
</style>

<template>
  <Modal
    modalName="servitudeSymbologyModal"
    title="Wizualizuj służebności na mapie"
    @closed="closed()"
    @opened="getStatuses(), getOwnerTypes()"
  >
    <v-layout>
      <v-switch
        class="checkbox"
        v-model="showLayer"
        label="Dodaj warstwę na mapę"
      >
      </v-switch>
    </v-layout>
    <v-layout>
      <div class="select__wrapper">
        <v-subheader
          class="font--primary"
          style="height: 15px;"
        >Klasyfikuj na podstawie</v-subheader>
        <v-flex xs12>
          <v-select
            :items="categories"
            item-text="displayName"
            :return-object="true"
            v-model="chosenCategory"
            :height="16"
            placeholder="Klasyfikuj na podstawie"
            id="selectClassification"
          >
          </v-select>
        </v-flex>
      </div>
    </v-layout>
    <v-layout>
      <v-list
        subheader
        style="width: 100%"
        v-if="chosenCategory!=undefined"
      >
        <v-list-tile
          v-for="(element, index) in chosenCategory.list"
          :key="index"
          class="list--el"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{element.name}}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <verte
              display="picker"
              menuPosition="right"
              :draggable="true"
              model="rgb"
              @input="colorChanged(element)"
              :value="element.color"
              v-model="element.color"
            >
            </verte>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import verte from 'verte';
import 'verte/dist/verte.css';

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import filter from "lodash/filter";
import each from "lodash/each";
import debounce from "lodash/debounce";

mixin(_, {
  chain,
  each,
  map,
  filter,
  debounce,
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    Modal,
    verte

  },
  data: () => ({
    showLayer: false,
    ignore : false,
    chosenCategory: undefined,
    categories: [
      {
        displayName: "Status służebności",
        name: "status",
        list: [],
        colorsDict: {}
      },
      {
        displayName: "Typ właściciela",
        name: "owner_type",
        list: [],
        colorsDict: {}
      }
    ],
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  watch: {
    showLayer(_new) {
      if (this.ignore) {
        this.ignore = false;
        return;
      }
      this.toggleLayer(_new);
    },
    chosenCategory(val) {
      if (val) {
        this.$root.$emit("setFeaturesServitudeStyle", undefined, 'empty');
        val.list.forEach(element => {
          this.$root.$emit("setFeaturesServitudeStyle", element);
        });
      }
    },
  },
  methods: {
    getStatuses() {
      let payload = {
        schema: "registry",
        table: "transmission_easement",
        column: "status"
      };
      this.$store.dispatch("getDictSTC", payload).then(r => {
        if(!r) {
          return;
        } else {
          if(localStorage.servitudesSymbologyStatuses) {
            let symbology = JSON.parse(localStorage.servitudesSymbologyStatuses);
            
            //weryfikacja zmien kluczy
            symbology = _(r.values)
                .map((value) => {
                  let exist = _.filter(symbology, (symbol) => symbol.name === value);

                  if (exist.length === 0) {
                    return {
                      color: 'rgb(155,155,155)',
                      name: value
                    };
                  } else {
                    return exist[0];
                  }
              }).value();
            
            this.categories[0].list = symbology;
            localStorage.servitudesSymbologyStatuses = JSON.stringify(symbology);
          } else {
            this.categories[0].list = _.map(r.values, (value) => ({
              color: 'rgb(155,155,155)',
              name : value
            }));
          }
        }
      });
    },
    getOwnerTypes() {
      let payload = {
        schema: "registry",
        table: "transmission_easement",
        column: "owner_type"
      }
      this.$store.dispatch("getDictSTC", payload).then(r => {
        if(!r) {
          return;
        } else {
          if(localStorage.servitudesSymbologyOwners) {
            let symbology = JSON.parse(localStorage.servitudesSymbologyOwners)
            //weryfikacja zmien kluczy
            symbology = _(r.values)
                .map((value) => {
                  let exist = _.filter(symbology, (symbol) => symbol.name === value);

                  if (exist.length === 0) {
                    return {
                      color: 'rgb(155,155,155)',
                      name: value
                    };
                  } else {
                    return exist[0];
                  }
              }).value();
            
            this.categories[1].list = symbology;
            localStorage.servitudesSymbologyOwners = JSON.stringify(symbology);
          } else {
            this.categories[1].list = _.map(r.values, (value) => ({
              color: 'rgb(155,155,155)',
              name : value
            }));
          }
        }
      });
    },
    toggleLayer(val) {
      this.$root.$emit("toggleServitudesLayer", val);
    },
    colorChanged: _.debounce(function (element) {
      element.category = this.chosenCategory.name;
      this.saveSymbology();
      this.$root.$emit("setFeaturesServitudeStyle", element);
    }, 500),
    saveSymbology() {
      if (this.chosenCategory.name === "status") {
        localStorage.servitudesSymbologyStatuses = JSON.stringify(this.chosenCategory.list);
      } else {
        localStorage.servitudesSymbologyOwners = JSON.stringify(this.chosenCategory.list);
      }
    },
    setSwitchFalse() {
      this.showLayer = false;
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    closed() {
      this.chosenCategory = undefined;
      
      this.ignore = true;
      this.showLayer = false;
    },
  },
  mounted() {
    this.$root.$on("setSwitchFalse", this.setSwitchFalse);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/servitude/modals/ServitudeSymbology.vue